import React from 'react';
import './bookingError.css';
import logo from "../../../assets/images/logo.png";

function BookingError({ code }) {

    const errorMessages = {
        400: {
            title: "An error occurred while processing your payment!",
            message: "Please check your payment credentials, and try again. Contact us for further assistance."
        },
        404: {
            title: "An error has occurred while processing your payment!",
            message: "Your payment has succeeded, but we were unable to confirm your booking. Please try to book again or contact us for assistance."
        },
        default: {
            title: "An unexpected error occurred!",
            message: "Please try again later or contact us for assistance."
        }
    }

    if (!errorMessages[code]) {
        code = 'default';
    }

    return (
        <div className='error-page'>
            <div className="error-nav">
                <div className="error-logo">
                    <img className="error-logo-img" src={logo} alt='Hymus Sports' />
                </div>
            </div>

            <div className='error-container'>
                <img className='error-img' src={logo} alt='Hymus Logo' />
                <h2 className='error-title'>{errorMessages[code].title}</h2>
                <p className='error-txt'>{errorMessages[code].message}</p>
                <div className='error-btn'>
                    <a href='/'>RETURN HOME</a>
                </div>
            </div>
        </div>
    );
}

export default BookingError;